function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_4111",
  "data-name": "Group 4111",
  transform: "translate(2690.446 56.568)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_74",
  "data-name": "Line 74",
  x2: 415.109,
  transform: "translate(-2681.778 135.343)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5153",
  "data-name": "Path 5153",
  d: "M-2640.616,305.325s-7.78-19.519-18.755-24.52",
  transform: "translate(-17.787 -197.628)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5154",
  "data-name": "Path 5154",
  d: "M-2677.159,266.376s-8.37-13.3-11.7-9.447C-2693.42,262.2-2677.159,266.376-2677.159,266.376Z",
  transform: "translate(0 -183.199)",
  fill: "#aeafae",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5155",
  "data-name": "Path 5155",
  d: "M-2649.7,302.5c-2.981-6.448-11.647,5.813-11.647,5.813S-2648.079,306.012-2649.7,302.5Z",
  transform: "translate(-16.627 -209.267)",
  fill: "#aeafae",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5156",
  "data-name": "Path 5156",
  d: "M-2599.4,221.841c1.563,19.692,5.936,49.237,5.936,49.237",
  transform: "translate(-52.997 -163.011)",
  fill: "#231f20",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5157",
  "data-name": "Path 5157",
  d: "M-2606.1,176.579c2.493-.247,9.875,21.729.733,20.67C-2613.471,196.31-2606.1,176.579-2606.1,176.579Z",
  transform: "translate(-47.26 -136.437)",
  fill: "#aeafae",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5158",
  "data-name": "Path 5158",
  d: "M-2624.65,237.781s-4.3-7.24-11.384-7.8-8.2,0-8.2,0",
  transform: "translate(-26.676 -167.647)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5159",
  "data-name": "Path 5159",
  d: "M-2664.361,223.774c-1.27-8.33-13.684,1.667-13.684,1.667S-2663.492,229.47-2664.361,223.774Z",
  transform: "translate(-6.824 -162.2)",
  fill: "#aeafae",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5160",
  "data-name": "Path 5160",
  d: "M-2594.175,249.145a30.548,30.548,0,0,1,12.048-11.673,56.668,56.668,0,0,1,10.211-4.684",
  transform: "translate(-56.063 -169.438)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5161",
  "data-name": "Path 5161",
  d: "M-2539.57,224.739c-2.712-9.967,20.282-3.738,20.282-3.738S-2537.642,231.824-2539.57,224.739Z",
  transform: "translate(-87.991 -161.389)",
  fill: "#aeafae",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5162",
  "data-name": "Path 5162",
  d: "M-2553.991,317.839s-.417-12.739,4.168-16.348",
  transform: "translate(-79.649 -209.773)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5163",
  "data-name": "Path 5163",
  d: "M-2529.752,273.192s-22.074,4.446-16.359,11.685C-2542.255,289.759-2529.752,273.192-2529.752,273.192Z",
  transform: "translate(-83.727 -193.159)",
  fill: "#aeafae",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5164",
  "data-name": "Path 5164",
  d: "M-2569.067,286.951c5.156-2.422,6.25,12.606,6.25,12.606S-2574.116,289.323-2569.067,286.951Z",
  transform: "translate(-70.041 -201.082)",
  fill: "#aeafae",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2707",
  "data-name": "Rectangle 2707",
  width: 37.368,
  height: 27.646,
  transform: "translate(-2664.018 107.697)",
  fill: "#ce1212",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5165",
  "data-name": "Path 5165",
  d: "M-2194.24,296.832l38.281-77.626h103.083l-33.89,77.626Z",
  transform: "translate(-290.861 -161.464)",
  fill: "#ce1212",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5166",
  "data-name": "Path 5166",
  d: "M-2014.871,303.745s-3.959-1.076-6.773.9c-1.22.858-5.063,3.855-3.053,6.356s5.762.313,7.22-1.875A29.658,29.658,0,0,0-2014.871,303.745Z",
  transform: "translate(-390.063 -210.924)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5167",
  "data-name": "Path 5167",
  d: "M-1807.9,190.8l13.615-105.167L-1856,52.016",
  transform: "translate(-489.438 -63.308)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5168",
  "data-name": "Path 5168",
  d: "M-1898.421,52.016l-29.834,12.642,30.425,18.894Z",
  transform: "translate(-447.018 -63.308)",
  fill: "#ce1212",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_645",
  "data-name": "Ellipse 645",
  cx: 7.892,
  cy: 7.892,
  r: 7.892,
  transform: "translate(-2368.352 4.113)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2708",
  "data-name": "Rectangle 2708",
  width: 40.072,
  height: 8.517,
  transform: "translate(-2317.639 126.414)",
  fill: "#dadada",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5169",
  "data-name": "Path 5169",
  d: "M-2031.01,87.442l-4.289-2.918s-10.471,12.4-7.242,14.952C-2039.01,102.267-2031.01,87.442-2031.01,87.442Z",
  transform: "translate(-379.559 -82.394)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_646",
  "data-name": "Ellipse 646",
  cx: 9.71,
  cy: 9.71,
  r: 9.71,
  transform: "translate(-2417.164 -14.307)",
  fill: "#cfcfcf",
  stroke: "#020202",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_647",
  "data-name": "Ellipse 647",
  cx: 5.758,
  cy: 5.758,
  r: 5.758,
  transform: "translate(-2413.212 -9.887)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5170",
  "data-name": "Path 5170",
  d: "M-2041.266,104.482a4.754,4.754,0,0,0,1.252,3.186,6.048,6.048,0,0,0,2.309,1.235s-2.987,3.923-4.862,2.2S-2041.266,104.482-2041.266,104.482Z",
  transform: "translate(-379.559 -94.111)",
  fill: "#cfcfcf",
  stroke: "#020202",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_648",
  "data-name": "Ellipse 648",
  cx: 12.573,
  cy: 12.573,
  r: 12.573,
  transform: "translate(-2519.27 -55.818)",
  fill: "#ce1212",
  stroke: "#020202",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5171",
  "data-name": "Path 5171",
  d: "M-2261.946-44.654c5.116.783,8.771,2.975,9.325,6.1.891,5.024-6.708,9.658-16.832,11.452s-18.938.071-19.828-4.953c-.5-2.8,1.616-5.766,5.341-8.148",
  transform: "translate(-235.021 -6.554)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_649",
  "data-name": "Ellipse 649",
  cx: 2.64,
  cy: 2.64,
  r: 2.64,
  transform: "translate(-2532.083 -31.608)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_650",
  "data-name": "Ellipse 650",
  cx: 10.555,
  cy: 10.555,
  r: 10.555,
  transform: "translate(-2614.781 -6.007)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_75",
  "data-name": "Line 75",
  x1: 5.696,
  y1: 1.32,
  transform: "translate(-2607.001 6.907)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_76",
  "data-name": "Line 76",
  x1: 3.404,
  y1: 4.029,
  transform: "translate(-2602.069 1.211)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5172",
  "data-name": "Path 5172",
  d: "M-2495.51,82.926s-1.042-1.667-.347-2.709,2.5,0,2.5,0,0-2.778.972-3.543c.772-.607,2.64.625,2.64.625",
  transform: "translate(-113.645 -77.686)",
  fill: "none",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5173",
  "data-name": "Path 5173",
  d: "M-2466.905,94.072s2.431.834,2.292,2.153-5.974,8.266-7.293,8.405-2.443-2.112-2.443-2.112,3.618-1.434,4.871-3.5S-2466.905,94.072-2466.905,94.072Z",
  transform: "translate(-126.412 -87.999)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5174",
  "data-name": "Path 5174",
  d: "M-2459.474,103.053s2.258.112,2.049,1.432-5.015,6.889-6.532,6.147c-1.137-.556-1.239-1.427-.581-2.079C-2463.459,107.486-2459.474,103.053-2459.474,103.053Z",
  transform: "translate(-131.933 -93.272)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5175",
  "data-name": "Path 5175",
  d: "M-2452.539,109.263l3.408,3.07s-2.438,3.369-3.147,3.3-3.923-2.289-3.923-2.289Z",
  transform: "translate(-137.067 -96.918)",
  fill: "#fff",
  stroke: "#231f20",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5176",
  "data-name": "Path 5176",
  d: "M-2419.227,30.487A111.757,111.757,0,0,1-2391.3,6.342",
  transform: "translate(-158.774 -36.494)",
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5177",
  "data-name": "Path 5177",
  d: "M-2402.993,42.04a78.205,78.205,0,0,1,17.574-17.782",
  transform: "translate(-168.305 -47.012)",
  fill: "#fff",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5178",
  "data-name": "Path 5178",
  d: "M-2146.278-17.967s17.922,1.389,35.843,18.06",
  transform: "translate(-319.019 -22.222)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_5179",
  "data-name": "Path 5179",
  d: "M-2129.539.79a68.34,68.34,0,0,1,25.423,13.441",
  transform: "translate(-328.847 -33.234)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}));

function SvgProblem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 424.527,
    height: 192.686,
    viewBox: "0 0 424.527 192.686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProblem);
export default __webpack_public_path__ + "static/media/problem.be16707f.svg";
export { ForwardRef as ReactComponent };